import React from 'react';

import Button from 'components/Button';
import Icon from 'components/Icon';

export default function VerticalNavItem({
  description,
  depth,
  href,
  icon,
  label,
  onClick,
  variant,
  ...props
}) {
  return (
    <Button
      as={href ? undefined : 'span'}
      className="nav-menu-item"
      data-depth={depth}
      href={href}
      size="sm"
      variant={variant || null}
      {...props}
    >
      {icon && <Icon name={icon} />}
      <span>{label}</span>
    </Button>
  );
}
